import { Col, Row, Tabs, Divider, Select } from "antd";
import { useSelector } from "react-redux";
import ACCELERATION from "../../../../../assets/images/icons/acceleration-distance.svg";
import { useEffect, useState, useMemo } from "react";
import AddToCompare from "../addToCompare";
import { TEST_RIDE_SUMMARY } from "../../../../Common/Grafana/Constants";
import FullGraphsModal from "./fullGraphsModal";
import CardCollapse from "../../../../Common/CardCollapse";
import panelList from "../panelList.json";
import GetIframe from "../../../../Common/Grafana/GetIframe";

const AccelerationAnalytics = ({
  baseUrl,
  baseFilterObject,
  compareValue,
  updateCompareValue,
}) => {
  const [selectedTab, setSelectedTab] = useState("0-20");
  const vehicleDetails = useSelector((state) => state.eol.vehicleDetails);
  const tripSummary = useSelector((state) => state.testRide.tripSummary);
  const [accelerationList, setAccelerationList] = useState([]);

  useEffect(() => {
    setAccelerationList([panelList?.acceleration[0]]);
  }, []);

  const baseFilterValues = useMemo(() => {
    return { ...baseFilterObject, accl_range: selectedTab };
  }, [baseFilterObject, selectedTab]);

  const onChangeTab = (value) => {
    setSelectedTab(value);
  };

  const onSelectAcceleration = (selectedValues) => {
    const selectedObjects = panelList?.acceleration?.filter((item) =>
      selectedValues.includes(item.var_name)
    );
    setAccelerationList(selectedObjects);
  };

  const items = [
    {
      key: "0-20",
      label: "0-20",
    },
    {
      key: "0-40",
      label: "0-40",
    },
    {
      key: "0-60",
      label: "0-60",
    },
    {
      key: "0-80",
      label: "0-80",
    },
  ];

  const subContent = (
    <Row gutter={[16, 16]} justify="space-between" className="mt05">
      <Col xs={24} sm={24} md={24} lg={16} xl={16}>
        <Select
          value={accelerationList?.map((item) => item.var_name)}
          mode="tags"
          style={{ width: "100%" }}
          onChange={onSelectAcceleration}
          options={panelList?.acceleration?.map((i) => ({
            label: i.title,
            value: i.var_name,
          }))}
        />
      </Col>

      <Col xs={12} sm={12} md={12} lg={4} xl={4} className="flex-center">
        Max: <span className="ml025 bold">{tripSummary?.maxAcceleration}</span>
      </Col>
      <Col xs={12} sm={12} md={12} lg={4} xl={4} className="flex-center">
        Min: <span className="ml025 bold">{tripSummary?.minAcceleration}</span>
      </Col>
    </Row>
  );

  return (
    <CardCollapse
      cardClassName={"ride-statistic-analytics-card"}
      title={"Acceleration"}
      icon={ACCELERATION}
      subContent={subContent}
    >
      <Row className="mt105 pd0">
        <Col span={24}>
          <Tabs
            activeKey={selectedTab}
            items={items}
            type="card"
            onChange={onChangeTab}
            className="celeration-tab-view"
            tabBarExtraContent={
              <FullGraphsModal
                modalTitle="Acceleration"
                vehicleDetails={vehicleDetails}
                baseUrl={baseUrl}
                baseFilterObject={baseFilterValues}
                variableKeys={TEST_RIDE_SUMMARY.ACCL_VARIABLES}
                chartList={["AccelerationDistance", "AccelerationDuration"]}
              />
            }
          />
          <Row className="pd0">
            {accelerationList?.map((panel, index) => (
              <Col key={index} span={24}>
                {vehicleDetails?.imeiNumber && (
                  <Row gutter={[12, 12]} className="pdtb05">
                    <Col span={24} id={`${panel.title}-timeseries`}>
                      <GetIframe
                        title={panel.title}
                        url={baseUrl}
                        panelId={
                          TEST_RIDE_SUMMARY.PANEL_ID[panel.var_name][
                            "timeSeries"
                          ]
                        }
                        variableObject={baseFilterValues}
                        variableKeys={TEST_RIDE_SUMMARY.ACCL_VARIABLES}
                        width="100%"
                        height="240"
                        divId={`${panel.title}-timeseries`}
                      />
                    </Col>
                  </Row>
                )}
                <Row className="mt1 mb1">
                  <Col className="add-compare-col">
                    <AddToCompare
                      value={panel.var_name}
                      compareValue={compareValue}
                      updateCompareValue={updateCompareValue}
                    />
                  </Col>
                </Row>
                {accelerationList?.length !== index + 1 ? (
                  <Divider className="compare-divider" />
                ) : null}
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </CardCollapse>
  );
};

export default AccelerationAnalytics;
